<tam-group-box [groupTitle]="fieldName" (deletionBtnClicked)="onSectionDeleting($event)">
    <form [formGroup]="sectionFrmGroup" class="section-root">
        <div class="field-container">
            <label>Data Provider<span class="is-required">&nbsp;*</span></label>
            <kendo-combobox formControlName="providername" [popupSettings]="{appendTo: 'root'}"
                [data]="filteredProviders" (filterChange)="onProviderFilterChange($event)" [filterable]="true"
                [textField]="'name'" [valueField]="'id'" [valuePrimitive]="true">
                <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <tam-mdl-dialog-field-section-provider-item [itemData]="dataItem">
                    </tam-mdl-dialog-field-section-provider-item>
                </ng-template>
            </kendo-combobox>
        </div>
        <div class="field-container">
            <label>Column with the value<span class="is-required">&nbsp;*</span></label>
            <kendo-combobox formControlName="mdlfieldname" [popupSettings]="{appendTo: 'root'}"
                (filterChange)="onProviderColumnFilterChange($event)" [filterable]="true"
                [data]="filteredProviderColumns" [textField]="'name'" [valueField]="'name'" [valuePrimitive]="true">
            </kendo-combobox>
        </div>
        <div class="field-container">
            <label>Select the row using the value in this field<span class="is-required">&nbsp;*</span></label>
            <kendo-combobox formControlName="fieldname" [popupSettings]="{appendTo: 'root'}"
                (filterChange)="onEntityFilterChange($event)" [filterable]="true" [data]="filteredEntityColumns"
                [textField]="'label'" [valueField]="'controlID'" [valuePrimitive]="true">
            </kendo-combobox>
        </div>
    </form>
</tam-group-box>
